import { ICardGroupInsertUpdate } from '../../models/cardgroup.interface';

/**
 * Widget to display a list of Card Groups that can be removed and added to a terminal
 * 
 * @param {ICardGroupInsertUpdate[]} data the card group list array
 * @param {HTMLElement} container the parent container for the generated list of elements
 * 
 * @returns void
 */
export const cardGroupListWidget = ( data: Array<ICardGroupInsertUpdate>, container: HTMLElement ) => {
  if ( !Array.isArray(data) || !container ) return;

  data.forEach((e: ICardGroupInsertUpdate) => {
    const div = document.createElement('div');
    div.className = `list-results-widget key_${e.cardGroupId}`;        

    const span = document.createElement('span');
    span.textContent = `${e.cardGroupName}`;

    const addButton = document.createElement('a');
    addButton.className = 'aafp_btn-form btn_theme-primary get-selected-element';
    addButton.id = `aafp_add-customer-${e.cardGroupId}`;
    addButton.textContent = 'SELECT';
    addButton.setAttribute(`data-id`, String(e.cardGroupId));
    addButton.setAttribute('data-name', e.cardGroupName);

    div.appendChild(span);
    div.appendChild(addButton);

    if ( data.length > 1 ) {
      container.appendChild(div);  
    } else {
      container.prepend(div);  
    }
  });

  data.length = 0;
}